import React, { useCallback, useEffect, useState } from 'react';

import { Control, Divider, Fold, Margin, Page } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';

import { lunaStreamsClient } from 'api';
import { DEFAULT_LOGS_PAGE_SIZE } from 'helpers/constants';

import { selectStreamOptions } from '../streams/selectors';
import { fetchStreams } from '../streams/store';
import { Logs } from './components/Logs';
import { LogsFilters } from './LogsFilterForm';
import st from './LogsPage.module.sass';

const defaultValues = {
  log_time__gte: null,
  log_time__lt: null,
  statuses: [],
  stream_ids: [],
  account_id: undefined,
  page: 1,
  page_size: 50,
};

function LogsPageComponent({ streamIdsOptions }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [filters, setFilters] = useState(defaultValues);
  const [logsData, setLogsData] = useState([]);
  const [updatingLogs, setUpdatingLogs] = useState(false);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_LOGS_PAGE_SIZE);

  const formMethods = useForm({ defaultValues: filters });

  const { reset, handleSubmit } = formMethods;

  const updateLogs = useCallback(async (params) => {
    setUpdatingLogs(true);
    const queryStrings = {
      ...filters,
      ...params,
    };

    const { data } = await lunaStreamsClient.logs.getLogs(queryStrings);

    setLogsData(data.logs);
    setUpdatingLogs(false);
  }, [filters]);

  const onResetPagination = () => {
    setPage(0);
    setPageSize(DEFAULT_LOGS_PAGE_SIZE);
  };

  const onSetFilters = async (formValues) => {
    if (updatingLogs) return undefined;
    setLogsData([]);

    setFilters(formValues);
    onResetPagination();
    return updateLogs(formValues);
  };

  const resetFilterLogs = () => {
    reset(defaultValues);
    handleSubmit(onSetFilters);
    onResetPagination();
  };

  useEffect(() => {
    dispatch(fetchStreams);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const context = {
    ...formMethods,
    setFilters,
  };

  return (
    <Page title={t('lunaStreamsLogs:название раздела')}>
      <Divider />
      <Fold
        isOpen
        title={t('lunaStreamsLogs:заголовок.фильтры')}
      >
        <div className={st.LogsFilters}>
          <FormProvider {...context}>
            <form onSubmit={handleSubmit(onSetFilters)}>
              <LogsFilters streamIdsOptions={streamIdsOptions} />

              <Divider small />

              <Control.Button
                disabled={updatingLogs}
                type="submit"
              >
                {t('lunaStreamsLogs:действия.отфильтровать')}
              </Control.Button>

              <Margin left>
                <Control.Button
                  kind="attention"
                  onClick={resetFilterLogs}
                  type="submit"
                >
                  {t('lunaStreamsLogs:действия.сбросить')}
                </Control.Button>
              </Margin>
            </form>
          </FormProvider>

        </div>
      </Fold>

      <Divider small />

      <Logs
        fetchData={updateLogs}
        logsData={logsData}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </Page>
  );
}

LogsPageComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  streamIdsOptions: PropTypes.arrayOf(PropTypes.object),
};

LogsPageComponent.defaultProps = {
  streamIdsOptions: [],
};

export const LogsPage = connect((state) => ({
  streamIdsOptions: selectStreamOptions(state),

}))(LogsPageComponent);
